// extracted by mini-css-extract-plugin
export default {"dialog":"default_dialog__DFgkj","controls":"default_controls__Vhcm0"};